// Yoyo
import {parseRawUrls} from '../common';

export default parseRawUrls({
  yoyo_angry: 'https://emojis.slackmojis.com/emojis/images/1492722318/2062/angry.gif',
  yoyo_attitude: 'https://emojis.slackmojis.com/emojis/images/1492722347/2063/attitude.gif',
  yoyo_blow_up: 'https://emojis.slackmojis.com/emojis/images/1492722347/2064/blow_up.gif',
  yoyo_bullhorn: 'https://emojis.slackmojis.com/emojis/images/1492722348/2065/bullhorn.gif',
  yoyo_chest_thump: 'https://emojis.slackmojis.com/emojis/images/1492722348/2066/chest_thump.gif',
  yoyo_cough: 'https://emojis.slackmojis.com/emojis/images/1492722349/2067/cough.gif',
  yoyo_entranced: 'https://emojis.slackmojis.com/emojis/images/1492722349/2068/entranced.gif',
  yoyo_excited2: 'https://emojis.slackmojis.com/emojis/images/1492722350/2069/excited.gif',
  yoyo_eyebrows: 'https://emojis.slackmojis.com/emojis/images/1492722350/2070/eyebrows.gif',
  yoyo_good_job2: 'https://emojis.slackmojis.com/emojis/images/1492722351/2071/good_job.gif',
  yoyo_haha: 'https://emojis.slackmojis.com/emojis/images/1492722351/2072/haha.gif',
  yoyo_headbutt: 'https://emojis.slackmojis.com/emojis/images/1492722351/2073/headbutt.gif',
  yoyo_hiding: 'https://emojis.slackmojis.com/emojis/images/1492722352/2074/hiding.gif',
  yoyo_holding_bomb: 'https://emojis.slackmojis.com/emojis/images/1492722352/2075/holding_bomb.gif',
  yoyo_injured: 'https://emojis.slackmojis.com/emojis/images/1492722353/2077/injured.gif',
  yoyo_in_love: 'https://emojis.slackmojis.com/emojis/images/1492722353/2076/in_love.gif',
  yoyo_looking: 'https://emojis.slackmojis.com/emojis/images/1492722353/2078/looking.gif',
  yoyo_lookout: 'https://emojis.slackmojis.com/emojis/images/1492722354/2079/lookout.gif',
  yoyo_love: 'https://emojis.slackmojis.com/emojis/images/1492722354/2080/love.gif',
  yoyo_money_bath: 'https://emojis.slackmojis.com/emojis/images/1492722355/2081/money_bath.gif',
  yoyo_nudge: 'https://emojis.slackmojis.com/emojis/images/1492722355/2082/nudge.gif',
  yoyo_pointing: 'https://emojis.slackmojis.com/emojis/images/1492722360/2083/pointing.gif',
  yoyo_puking2: 'https://emojis.slackmojis.com/emojis/images/1492722364/2084/puking.gif',
  yoyo_quivering: 'https://emojis.slackmojis.com/emojis/images/1492722365/2085/quivering.gif',
  yoyo_reading: 'https://emojis.slackmojis.com/emojis/images/1492722365/2086/reading.gif',
  yoyo_say_nothing: 'https://emojis.slackmojis.com/emojis/images/1492722366/2087/say_nothing.gif',
  yoyo_scared: 'https://emojis.slackmojis.com/emojis/images/1492722366/2088/scared.gif',
  yoyo_scheming: 'https://emojis.slackmojis.com/emojis/images/1492722366/2089/scheming.gif',
  yoyo_see_money: 'https://emojis.slackmojis.com/emojis/images/1492722366/2090/see_money.gif',
  yoyo_sick: 'https://emojis.slackmojis.com/emojis/images/1492722367/2091/sick.gif',
  yoyo_surrender: 'https://emojis.slackmojis.com/emojis/images/1492722367/2092/surrender.gif',
  yoyo_sweaty: 'https://emojis.slackmojis.com/emojis/images/1492722367/2093/sweaty.gif',
  yoyo_whining: 'https://emojis.slackmojis.com/emojis/images/1492722368/2094/whining.gif',
  yoyo_whisper: 'https://emojis.slackmojis.com/emojis/images/1492722368/2095/whisper.gif',
  yoyo_yelling: 'https://emojis.slackmojis.com/emojis/images/1492722374/2096/yelling.gif',
  yoyo_zombie2: 'https://emojis.slackmojis.com/emojis/images/1492722378/2097/zombie.gif',
});
